import { setupWorker } from 'msw';

import { mocks } from '../api/mocks';


export const worker = setupWorker(...mocks);
